import React from "react";
import ChevronDownIcon from "@heroicons/react/20/solid/ChevronDownIcon";

const Accordion = ({ items, openIndices, onToggle }) => {
  const toggleAccordion = (index) => {
    onToggle(index);
  };

  return (
    <div>
      {items.map((item, index) => (
        <div
          key={index}
          className="max-w-4xl mx-auto p-6 bg-white dark:bg-gray-800 rounded-md shadow-md mt-6"
        >
          <button
            className="w-full text-left font-semibold focus:outline-none text-xl flex justify-between items-center"
            onClick={() => toggleAccordion(index)}
          >
            <div className="flex items-center gap-3">
              {item.icon}
              {item.title}
            </div>
            <ChevronDownIcon className="w-6 h-6" />
          </button>

          {openIndices.includes(index) && (
            <div className="mt-4">{item.content}</div>
          )}
        </div>
      ))}
    </div>
  );
};

export default Accordion;
